<div
  class="flex flex-col items-center justify-center bg-[#EEF4FD] rounded pt-8 pb-8 pl-8 pr-8 h-fit w-full gap-[23.4px] min-[1024px]:rounded-lg min-[1024px]:pt-12 min-[1024px]:pb-12 min-[1024px]:pl-12 min-[1024px]:pr-12 min-[1024px]:flex-col min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:gap-0"
>
  <!-- Desktop: Container wrapping heading + description + locations -->
  <div
    class="flex flex-col items-start justify-start h-fit w-full gap-[23.3px]"
  >
    <!-- Heading 2 -->
    <div
      class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
    >
      <span
        class="text-[#161C23] text-3xl font-semibold leading-9 tracking-normal text-left w-fit h-fit min-[1024px]:text-4xl min-[1024px]:leading-10 min-[1024px]:w-full"
      >
        Where We're Based
      </span>
    </div>

    <!-- Description Container -->
    <div
      class="flex flex-col items-center justify-center h-fit w-full pb-[0.625px] min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:max-w-[672px] min-[1024px]:pb-[0.75px]"
    >
      <span
        class="text-[#474747] font-normal text-left text-lg leading-[29.25px] tracking-normal w-fit h-fit min-[1024px]:text-xl min-[1024px]:leading-[32.5px] min-[1024px]:w-[637px] min-[1024px]:h-[65px]"
      >
        Our team spans multiple locations across Greece, mainly Thessaloniki and
        Athens, as well as Eindhoven in the Netherlands.
      </span>
    </div>

    <!-- Locations Container -->
    <div
      class="flex flex-col items-center justify-center h-fit w-full pt-[16.6px] pb-[24.6px] gap-8 min-[1024px]:flex-row min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:pt-[24.7px] min-[1024px]:pb-0 min-[1024px]:gap-0"
    >
      <!-- Thessaloniki -->
      <div
        class="flex flex-col items-center justify-center h-fit w-full gap-1 min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:gap-2"
      >
        <div
          class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
        >
          <span
            class="text-[#383B42] font-bold text-[10px] leading-[15px] tracking-[1px] uppercase text-left w-fit h-fit min-[1024px]:text-xs min-[1024px]:leading-4 min-[1024px]:tracking-[1.2px] min-[1024px]:w-full"
          >
            GREECE
          </span>
        </div>
        <div
          class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
        >
          <span
            class="text-[#161C23] font-bold text-2xl leading-8 tracking-normal text-left w-fit h-fit min-[1024px]:w-full"
          >
            Thessaloniki
          </span>
        </div>
      </div>

      <!-- Athens -->
      <div
        class="flex flex-col items-start justify-start h-fit w-full gap-1 min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:gap-2"
      >
        <div
          class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
        >
          <span
            class="text-[#383B42] font-bold text-[10px] leading-[15px] tracking-[1px] uppercase text-left w-fit h-fit min-[1024px]:text-xs min-[1024px]:leading-4 min-[1024px]:tracking-[1.2px] min-[1024px]:w-full"
          >
            GREECE
          </span>
        </div>
        <div
          class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
        >
          <span
            class="text-[#161C23] font-bold text-2xl leading-8 tracking-normal text-left w-fit h-fit min-[1024px]:w-full"
          >
            Athens
          </span>
        </div>
      </div>

      <!-- Eindhoven -->
      <div
        class="flex flex-col items-center justify-center h-fit w-full gap-1 min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:gap-2"
      >
        <div
          class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
        >
          <span
            class="text-[#383B42] font-bold text-[10px] leading-[15px] tracking-[1px] uppercase text-left w-fit h-fit min-[1024px]:text-xs min-[1024px]:leading-4 min-[1024px]:tracking-[1.2px] min-[1024px]:w-full"
          >
            NETHERLANDS
          </span>
        </div>
        <div
          class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
        >
          <span
            class="text-[#161C23] font-bold text-2xl leading-8 tracking-normal text-left w-fit h-fit min-[1024px]:w-full"
          >
            Eindhoven
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Margin / HorizontalBorder Section -->
  <div
    class="flex flex-col items-center justify-center h-fit w-full max-w-[300px] border-t border-[#C6C6C6] pt-6 pb-0 min-[1024px]:max-w-full min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:pt-8 min-[1024px]:mt-12"
  >
    <div
      class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start min-[1024px]:justify-start"
    >
      <span
        class="text-[#383B42] font-medium text-sm leading-5 tracking-normal text-left w-full h-fit min-[1024px]:text-lg min-[1024px]:leading-7"
      >
        Different cities. Same standards. Same care for the craft.
      </span>
    </div>
  </div>
</div>
